var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C9.65665 0 4.17565 3.69156 1.58765 9.0435H30.4123C27.8244 3.69156 22.3433 0 16 0V0Z",
    fill: "#338AF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C22.3433 32 27.8244 28.3085 30.4124 22.9565H1.58765C4.17565 28.3085 9.65665 32 16 32Z",
    fill: "#338AF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7821 16L18.8281 16.9192L19.8686 18.8116L17.7468 18.4057L17.4779 20.5492L16 18.9727L14.522 20.5492L14.2531 18.4057L12.1313 18.8116L13.1718 16.9191L11.2178 16L13.1718 15.0808L12.1313 13.1884L14.2531 13.5943L14.522 11.4508L16 13.0273L17.478 11.4508L17.7468 13.5943L19.8687 13.1884L18.8281 15.0809L20.7821 16Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/AR.1fea7ac4.svg";
export { ForwardRef as ReactComponent };